import React, { useState, useEffect } from 'react'
import Breadcrumb from '../../../Components/Breadcrumb/Breadcrumb'
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import Cookies from 'js-cookie';
import EvnVar from '../../../EnvVar';
import SocialMediaShare from '../../../Components/SocialMediaShare/SocialMediaShare';

function OtherActivities() {
  const baseURL = EvnVar()
  const token = Cookies.get("jwt")

  // slogan mdodal API
  // slogan mdodal
  const [sloganshow, setSloganShow] = useState(false);
  const sloganHandleClose = () => setSloganShow(false);
  const sloganHandleShow = () => setSloganShow(true);
  // slogan mdodal

  // Get API
  const url = "https://vitiyagyanmela.icai.org/";
  const [sloganTrigger, setSloganTrigger] = useState(false)
  const [sloganget, setSloganget] = useState(null)
  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseURL}/dash/slogan`,
      headers: {
          Authorization: token,
      },
      withCredentials: true,
  };

  axios
      .request(config)
      .then((response) => {
          let result = JSON.stringify(response.data);
          let data = JSON.parse(result);
          // console.log("Alll data Slogan", data);
          setSloganget(data);
          // console.log("result Slogan", JSON.parse(result));
      })
      .catch((error) => {
          console.log("Error fetching data:", error);
      });
      setSloganTrigger(false)
  }, [sloganTrigger]);


  // Post API
  const [sloganValue, setSloganValue] = useState(null);
  const sloganHangleChange = (e) => {
    e.preventDefault();
    setSloganValue(e.target.value)
  }

  const submitSlogan = (e) => {
    e.preventDefault();
    // console.log("sloganValue:", sloganValue)

    let sloganData = JSON.stringify({
      "slogan": sloganValue
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}/dash/slogan`,
      headers: {
        'content-type': 'application/json',
          Authorization: token,
      },
      data: sloganData,
      withCredentials: true,
  };

  axios
      .request(config)
      .then((response) => {
          // console.log(JSON.stringify(response.data));
          setSloganTrigger(true)
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Creative Poster API
  // Creative modal
  const [creativeshow, setCreativeShow] = useState(false);
  const creativeHandleClose = () => setCreativeShow(false);
  const creativeHandleShow = () => setCreativeShow(true);
  // Creative modal

  // Get API
  const [creativeTrigger, setCreativeTrigger] = useState(false)
  const [creativeget, setCreativeget] = useState(null)
  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseURL}/dash/CreativePost`,
      headers: {
          Authorization: token,
      },
      withCredentials: true,
  };

  axios
      .request(config)
      .then((response) => {
          let result = JSON.stringify(response.data);
          let data = JSON.parse(result);
          // console.log("Alll data creative", data);
          setCreativeget(data);
          // console.log("result creative", JSON.parse(result));
      })
      .catch((error) => {
          console.log("Error fetching data:", error);
      });
      setCreativeTrigger(false)
  }, [creativeTrigger]);


  // Post API
  const [creativeValue, setCreativeValue] = useState(null);
  const creativeHangleChange = (e) => {
    e.preventDefault();
    setCreativeValue(e.target.value)
  }

  const submitCreative = (e) => {
    e.preventDefault();
    // console.log("creativeValue:", creativeValue)

    let creativeData = JSON.stringify({
      "creativepost": creativeValue
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}/dash/CreativePost`,
      headers: {
        'content-type': 'application/json',
          Authorization: token,
      },
      data: creativeData,
      withCredentials: true,
  };

  axios
      .request(config)
      .then((response) => {
          // console.log(JSON.stringify(response.data));
          setCreativeTrigger(true)
      })
      .catch((error) => {
        console.log(error);
      });
  }


  // Story API
  // Story modal
  const [storyShow, setStoryShow] = useState(false);
  const storyHandleClose = () => setStoryShow(false);
  const storyHandleShow = () => setStoryShow(true);
  // Story modal

  // Get API
  const [storyTrigger, setStoryTrigger] = useState(false)
  const [storyget, setStoryget] = useState(null)
  useEffect(() => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseURL}/dash/story`,
      headers: {
          Authorization: token,
      },
      withCredentials: true,
  };

  axios
      .request(config)
      .then((response) => {
          let result = JSON.stringify(response.data);
          let data = JSON.parse(result);
          // console.log("Alll data story", data);
          setStoryget(data);
          // console.log("result story", JSON.parse(result));
      })
      .catch((error) => {
          console.log("Error fetching data:", error);
      });
      setStoryTrigger(false)
  }, [storyTrigger]);


  // Post API
  const [storyValue, setStoryValue] = useState(null);
  const storyHangleChange = (e) => {
    e.preventDefault();
    setStoryValue(e.target.value)
  }

  const storyCreative = (e) => {
    e.preventDefault();
    // console.log("storyValue:", storyValue)

    let storyData = JSON.stringify({
      "story": storyValue
    });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}/dash/story`,
      headers: {
        'content-type': 'application/json',
          Authorization: token,
      },
      data: storyData,
      withCredentials: true,
  };

  axios
      .request(config)
      .then((response) => {
          // console.log(JSON.stringify(response.data));
          setStoryTrigger(true)
      })
      .catch((error) => {
        console.log(error);
      });
  }

  return (
    <>
      <Breadcrumb data="FTL Activities" />
      <div className='content-body'>
        <div className="table-data">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="mb-0">Slogan</h5>
            <button className="btn btn-warning download-btn" variant="primary" onClick={sloganHandleShow}>Add</button>
          </div>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Slogan</th>
                  <th style={{width: "10%"}}>Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  sloganget && sloganget.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          {item.slogan}
                        </td>
                        <td>
                          <SocialMediaShare url={url} title={item.slogan} />
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
        <div className="table-data">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="mb-0">Creative/Post</h5>
            <button className="btn btn-warning download-btn" variant="primary" onClick={creativeHandleShow}>Add</button>
          </div>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Creative/Post</th>
                  <th style={{width: "10%"}}>Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  creativeget && creativeget.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          {item.posterlink}
                        </td>
                        <td>
                          <SocialMediaShare url={url} title={item.posterlink} />
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
        <div className="table-data">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="mb-0">Story</h5>
            <button className="btn btn-warning download-btn" variant="primary" onClick={storyHandleShow}>Add</button>
          </div>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Story</th>
                  <th style={{width: "10%"}}>Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  storyget && storyget.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          {item.story}
                        </td>
                        <td>
                          <SocialMediaShare url={url} title={item.story} />
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <Modal show={sloganshow} onHide={sloganHandleClose} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Add Slogan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitSlogan}>
            <div className='row'>
              <div className='col-lg-12 mb-3'>
              <textarea
              className='form-control'
              rows={5}
              type="text"
              id="slogan"
              name="slogan"
              placeholder="Enter slogan..."
              onChange={sloganHangleChange}
              required
            />
              </div>
              <div className='col-lg-12'>
              <button type='submit' className='download-btn d-flex ms-auto' onClick={sloganHandleClose}>Submit</button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>


      <Modal show={creativeshow} onHide={creativeHandleClose} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Add Creative Post</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitCreative}>
            <div className='row'>
              <div className='col-lg-12 mb-3'>
              <textarea
              className='form-control'
              rows={5}
              type="text"
              id="creative"
              name="creative"
              placeholder="Enter creative..."
              onChange={creativeHangleChange}
              required
            />
              </div>
              <div className='col-lg-12'>
              <button type='submit' className='download-btn d-flex ms-auto' onClick={creativeHandleClose}>Submit</button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>


      <Modal show={storyShow} onHide={storyHandleClose} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Add Story</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={storyCreative}>
            <div className='row'>
              <div className='col-lg-12 mb-3'>
              <textarea
              className='form-control'
              rows={5}
              type="text"
              id="creative"
              name="creative"
              placeholder="Enter story..."
              onChange={storyHangleChange}
              required
            />
              </div>
              <div className='col-lg-12'>
              <button type='submit' className='download-btn d-flex ms-auto' onClick={storyHandleClose}>Submit</button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default OtherActivities
